import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-screen h-screen items-center justify-start p-10" }
const _hoisted_2 = { class: "w-[50%] p-10 bg-white rounded-lg" }
const _hoisted_3 = { class: "flex flex-col gap-1 mb-4" }
const _hoisted_4 = { class: "flex flex-col gap-1" }
const _hoisted_5 = { class: "flex flex-col gap-1" }
const _hoisted_6 = {
  key: 0,
  class: "flex w-full mt-2"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "w-[100%] mt-[5%]" }

import { computed, ref } from 'vue';
import { useBlog } from '@/composables/useBlog';
import ContentEditor from '@/components/ContentEditor.vue';
import { uploadBlogCoverImage } from '@/service/blog.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogsManagerView',
  setup(__props) {

const title = ref('');
const content = ref('');
const metaDescription = ref('');
const coverImage = ref<File | null>(null);
const editorContent = ref('');

const coverImageDisplay = computed(() => (coverImage.value ? URL.createObjectURL(coverImage.value) : null));

const handleContentUpdate = (content: string) => {
  editorContent.value = content;
};

const onCoverImageChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files[0]) {
    const [file] = target.files;
    coverImage.value = file;
  }
};

async function submitBlog() {
  const { createBlog } = useBlog(); // Fetching the createBlog function from the composable

  if (!title.value || !editorContent.value || !metaDescription.value) {
    console.log(title.value, editorContent.value, metaDescription.value);
    alert('Please fill out all fields.');
    return;
  }

  let coverImageUrl = '';
  if (coverImage.value) {
    // Upload cover image to Firebase Storage
    coverImageUrl = await uploadBlogCoverImage(coverImage.value);
  }

  await createBlog(
    title.value,
    editorContent.value,
    metaDescription.value,
    coverImageUrl,
  );
  alert('Blog created successfully!');

  // Reset form or redirect after successful submission
  title.value = '';
  content.value = '';
  metaDescription.value = '';
  coverImage.value = null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-center font-bold text-3xl mb-10" }, " Create a New Blog Post ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("label", null, "Title", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
          type: "text",
          required: "",
          class: "border border-[#BC8809] rounded-md p-1 outline-[#505050]"
        }, null, 512), [
          [_vModelText, title.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("label", null, "Meta Description", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((metaDescription).value = $event)),
          type: "text",
          required: "",
          class: "border border-[#BC8809] rounded-md p-1 outline-[#505050]"
        }, null, 512), [
          [_vModelText, metaDescription.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { for: "coverImage" }, "Cover Image", -1)),
        _createElementVNode("input", {
          type: "file",
          onChange: onCoverImageChange,
          accept: "image/*"
        }, null, 32)
      ]),
      (coverImageDisplay.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: coverImageDisplay.value,
                alt: "Cover Image",
                class: "w-60 rounded-lg"
              }, null, 8, _hoisted_7)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(ContentEditor, { onUpdateContent: handleContentUpdate })
      ]),
      _createElementVNode("button", {
        class: "p-3 bg-[#BC8809] text-white w-full rounded-lg mt-5 hover:opacity-80 transition-colors",
        onClick: submitBlog
      }, " Add Blog ")
    ])
  ]))
}
}

})